import { render, staticRenderFns } from "./CRMLawcaseShouan.vue?vue&type=template&id=697efbb7&scoped=true&"
import script from "./CRMLawcaseShouan.vue?vue&type=script&lang=js&"
export * from "./CRMLawcaseShouan.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcaseShouan.vue?vue&type=style&index=0&id=697efbb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697efbb7",
  null
  
)

export default component.exports